<template>
  <audio id="audioHolder" ref="audioPlayer" autoplay controls controlsList="nodownload">
        <source :src="mediaPath" type="audio/mpeg"> {{$t('common.errors.audioTagError')}}
  </audio>
</template>

<script>
// import axios from 'axios'
export default {
  name: 'audioPlayer',
  loaded: true,
  props: ['path'],
  data () {
    return {
      mediaPath: this.path
    }
  },
  mounted () {
    // console.log('audio player path:' + this.mediaPath)
  },
  watch: {
    path: function (newValue, oldValue) {
      // console.log('audio:newpath:' + newValue + 'oldapth:' + oldValue)
      this.mediaPath = newValue
      this.audioHolder = document.getElementById('audioHolder')
      this.clone = this.audioHolder.cloneNode(true)
      this.clone.setAttribute('src', newValue)
      this.audioHolder.parentNode.replaceChild(this.clone, this.audioHolder)
      this.clone.play()
    }
  },
  beforeDestroy () {
    if (this.$store.getters.getIsPurchase(this.$store.getters.getcurrentPlayingContent.contentId)) {
      if (this.$store.getters.getIsplaylist) {
        this.$store.dispatch('updatePlayListLastItemViewedByPlaylistId', {'plId': this.$store.getters.getcurrentPlaylist.plId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': 0})
        /* return new Promise((resolve, reject) => {
          axios.post('r/contentviewer/updatedurationbycountno', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'playListId': this.$store.getters.getcurrentPlaylist.plId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': 0 })
          .then(response => {
            this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
            response()
          })
          .catch(err => {
            console.log(err)
            reject()
          })
        }) */
      } else {
        /* return new Promise((resolve, reject) => {
          axios.post('r/contentviewer/updatedurationbycountno', { 'profileId': this.$store.getters.getProfileDetails.profileId, 'itemId': this.$store.getters.getcurrentPlayingContent.contentId, 'lastViewedDuration': 0 })
          .then(response => {
            this.$store.dispatch('fetchEnrolledItems', this.$store.getters.getProfileDetails.profileId)
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject()
          })
        }) */
      }
    }
  }
}
</script>

<style>
#audioHolder{
  width: 100%;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/contentViewer/contentHelper/audioPlayer.vue?517eb8b0